import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import PostCard from "@/components/feature/PostCard";
import { siteMeta } from "@/mocks/siteMeta";
import { posts } from "@/mocks/posts";

const hotTags = ["名场面", "伏笔", "热词", "直拍", "榜单解读", "道具造型"];

export default function Hero() {
  const featured = posts[0];

  return (
    <section
      aria-labelledby="hero-title"
      className="relative w-full overflow-hidden bg-background-100 border-b border-background-200"
    >
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20editorial%20collage%20background%20with%20layered%20cream%20paper%20textures%2C%20vermilion%20and%20amber%20paint%20brush%20strokes%2C%20subtle%20film%20grain%2C%20soft%20cinematic%20light%2C%20artistic%20magazine%20backdrop%2C%20wide%20composition&width=1600&height=900&seq=hero-91-bg&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50 via-background-50/95 to-background-50/60"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 py-12 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="inline-flex items-center gap-2 bg-primary-50 border border-primary-200 text-primary-700 text-xs md:text-sm px-3 py-1.5 rounded-full">
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                {siteMeta.slogan}
              </span>
            </Reveal>

            <Reveal delay={80}>
              <h1
                id="hero-title"
                className="mt-5 font-heading font-black text-3xl md:text-5xl lg:text-[3.4rem] leading-[1.15] text-foreground-950 text-balance"
              >
                一个入口，
                <span className="text-primary-600">看遍爆料91</span>
                全部内容合集
              </h1>
            </Reveal>

            <Reveal delay={140}>
              <p className="mt-5 max-w-xl text-sm md:text-base leading-relaxed text-foreground-600">
                进入爆料91专区，栏目、频道、板块内容全都在这。热门合集统一归拢，一个页面对应整块专区，
                想看什么直接点，省得来回翻，也不怕找不到路。
              </p>
            </Reveal>

            <Reveal delay={200}>
              <div className="mt-8 flex flex-col sm:flex-row flex-wrap gap-3">
                <Link
                  to="/zones"
                  className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-primary-700 transition-colors"
                >
                  <i className="ri-layout-grid-fill"></i>
                  进入专区总览
                </Link>
                <Link
                  to="/ranking"
                  className="inline-flex items-center justify-center gap-2 h-12 px-6 rounded-md border border-foreground-300 text-foreground-900 text-sm font-medium whitespace-nowrap cursor-pointer hover:border-foreground-900 hover:bg-background-50 transition-colors"
                >
                  <i className="ri-fire-line"></i>
                  查看本周热榜
                </Link>
              </div>
            </Reveal>

            <Reveal delay={260}>
              <dl className="mt-10 grid grid-cols-2 sm:grid-cols-4 gap-5 max-w-xl">
                {siteMeta.stats.map((stat) => (
                  <div key={stat.label} className="flex flex-col">
                    <dd className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                      {stat.value}
                      <span className="text-sm font-medium text-foreground-500 ml-1">
                        {stat.unit}
                      </span>
                    </dd>
                    <dt className="mt-1 text-xs md:text-sm text-foreground-600">{stat.label}</dt>
                  </div>
                ))}
              </dl>
            </Reveal>

            <Reveal delay={320}>
              <div className="mt-8 flex flex-wrap items-center gap-2">
                <span className="text-xs text-foreground-500 mr-1">大家都在搜</span>
                {hotTags.map((tag) => (
                  <Link
                    key={tag}
                    to="/zones"
                    className="text-xs px-3 py-1.5 rounded-full bg-background-200/70 text-foreground-700 hover:bg-accent-100 hover:text-accent-900 transition-colors cursor-pointer"
                  >
                    #{tag}
                  </Link>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={200}>
              <div className="relative">
                <span className="absolute -top-3 -left-3 z-10 inline-flex items-center gap-1.5 bg-accent-500 text-foreground-950 text-xs font-medium px-3 py-1.5 rounded-full">
                  <i className="ri-bookmark-3-fill"></i>
                  本期主推合集
                </span>
                <PostCard post={featured} variant="wide" />
                <div className="mt-4 grid grid-cols-2 gap-3">
                  <Link
                    to={`/zone/${posts[1].zoneId}`}
                    className="rounded-lg border border-background-200 bg-background-50 p-4 hover:border-primary-300 transition-colors cursor-pointer"
                  >
                    <i className="ri-emotion-happy-line text-xl text-accent-700"></i>
                    <p className="mt-2 text-sm font-medium text-foreground-900">综艺吃瓜专区</p>
                    <p className="mt-1 text-xs text-foreground-500">名梗 · 嘉宾 · 剪辑</p>
                  </Link>
                  <Link
                    to={`/zone/${posts[4].zoneId}`}
                    className="rounded-lg border border-background-200 bg-background-50 p-4 hover:border-primary-300 transition-colors cursor-pointer"
                  >
                    <i className="ri-chat-smile-2-line text-xl text-secondary-700"></i>
                    <p className="mt-2 text-sm font-medium text-foreground-900">网络热梗专区</p>
                    <p className="mt-1 text-xs text-foreground-500">本周热词已更新</p>
                  </Link>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}